// Bileli · shared/i18n — GETTEXT-STYLE translation for the Bileli app: the RUSSIAN string IS the key,
// `t()` looks it up in the Kyrgyz map and falls back to the Russian text itself when missing. why this
// shape: hundreds of existing literals sweep mechanically (wrap, done), a changed Russian copy degrades
// to Russian instead of crashing, and module-level constants (TYPE_LABEL maps etc.) can stay Russian and
// be translated at the USAGE site. Reactivity is handled once: BileliWorkspace keys its root by the
// current lang, so a switch remounts every Bileli view and plain t() calls re-evaluate — no per-view hook.

import { KY } from './ky';
import { bileliLangStore } from './langStore';

export { type BileliLang, bileliLangStore, setBileliLang } from './langStore';

/** Translate a Russian source string; optional `{var}` placeholders are substituted after lookup. */
export function t(ru: string, vars?: Record<string, string | number>): string {
  const lang = bileliLangStore.getState().lang;
  let out = lang === 'ky' ? (KY[ru] ?? ru) : ru;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      // Function replacer: a plain-string replacement interprets $&, $$, $`, $' as substitution
      // patterns — teacher-authored values (lesson titles with "$…") would corrupt the output.
      out = out.replace(`{${k}}`, () => String(v));
    }
  }
  return out;
}

/** Backend categories carry both labels — pick by the current interface language. */
export function categoryLabel(c: { labelRu: string; labelKy?: string | null }): string {
  return bileliLangStore.getState().lang === 'ky' ? (c.labelKy || c.labelRu) : c.labelRu;
}
